/*global jQuery */
(function($) {

  'use strict';

  const sistemaDate = function() {
		$('.box_prodotti').each(function(){
			$('.data_blog_hover', this).css('bottom', '40px');
			if ($('.titolo_blog', this).height()>25) {
				$('.data_blog_hover', this).css('bottom', '60px');
			}
			if ($('.titolo_blog', this).height()>50) {
				$('.data_blog_hover', this).css('bottom', '80px');
			}
		});
	}

  $(document).ready(function(){
    
	    new Blazy({
	      selector: '.b-lazy',
	      breakpoints: [
	        {
	          width: 767,
	          src: 'data-src-small'
	        },
	        {
	          width: 991,
	          src: 'data-src-medium'
	        },
	        {
	          width: 1199,
	          src: 'data-src-large'
	        }
	      ]
	    });

    	sistemaDate();

	});

	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
	    $('.box_prodotti').show();
	} else {
	    $('.box_prodotti').hover(function() {
	      $('.nome_prodotto_intro', this).stop().fadeIn();
	    }, function() {
	      $('.nome_prodotto_intro', this).stop().fadeOut();
	    });
	}

	$(window).on('resize', function() {
		sistemaDate();
	});

	


}(jQuery));
